import axios from "axios";
import { create } from "zustand";

const authStore = create((set) => ({
  loggedIn: null,
  adminDetails: null,

  signInForm: {
    email: "",
    password: "",
  },

  fillSignInForm: (e) => {
    const { name, value } = e.target;
    set((state) => {
      return {
        signInForm: {
          ...state.signInForm,
          [name]: value,
        },
      };
    });
  },

  signIn: async () => {
    try {
      const { signInForm } = authStore.getState();
      const res = await axios.post("/sign-in", signInForm);

      set({
        adminDetails: res.data.admin,
        loggedIn: true,
        signInForm: {
          email: "",
          password: "",
        },
      });
    } catch (error) {
      console.log(error);
    }
  },

  checkAuth: async () => {
    try {
      const res = await axios.get("/check-auth");
      set({ adminDetails: res.data.admin });
      set({ loggedIn: true });
    } catch (error) {
      set({ loggedIn: false });
    }
  },

  signOut: async () => {
    await axios.get("/sign-out");
    set({ loggedIn: false });
  },
}));

export default authStore;
